import { Dayjs } from 'dayjs'
import React from 'react'
import { UseFormReturn } from 'react-hook-form'

export interface FormValues {
  clientId: any
  date: Array<Dayjs>
}

export interface IssuedCheckProcessingLogProps {
  form: UseFormReturn<FormValues>
  loading: boolean
  loadingClients: boolean
  clients: Array<{
    id: string | null
    clientName: string
  }>
  onSubmit: (values: FormValues) => Promise<any>
  handleGetClients: () => Promise<any>
}

export const IssuedCheckProcessingLogContext = React.createContext<IssuedCheckProcessingLogProps>({
  form: null as any,
  loading: false,
  loadingClients: false,
  clients: [],
  onSubmit: () => Promise.resolve({}),
  handleGetClients: () => Promise.resolve({}),
})

export const useIssuedCheckProcessingLogContext = () =>
  React.useContext<IssuedCheckProcessingLogProps>(IssuedCheckProcessingLogContext)
